module.exports = { BaseOutput: function BaseOutput() {} };